import { getRunningSeries, getContestId } from '../../services/ContestSeries';
import {
  FETCH_CONTESTS_SUCCESS,
  FETCH_CONTESTS_REQUEST,
  FETCH_CONTESTS_FAILURE,
  UPDATE_CONTEST_CLOSE,
  ADD_CONTEST_PLAYED,
  OMIT_CONTEST,
  UPDATE_CONTEST,
  FETCH_CONTESTS_STATUS,
} from './types';

// Util generate poolkey from contest
export const getContestSeriesKey = (contest:any) => {
  const {
    duration,
    assetType,
    instrumentPrices: [
      {
        instrument: { assetIdBase },
      },
    ],
  } = contest;

  return `${duration}-${assetType}-${assetIdBase}`;
}

export const fetchContestsRequests = () => ({
  type: FETCH_CONTESTS_REQUEST,
});

export const fetchContestsSuccess = (contests:any) => ({
  type: FETCH_CONTESTS_SUCCESS,
  payload: contests,
});

export const fetchContestsStatus = (boolean: boolean) =>({
  type: FETCH_CONTESTS_STATUS,
  payload: boolean,
})

export const fetchContestsFailure = (error:any) => ({
  type: FETCH_CONTESTS_FAILURE,
  payload: {
    error,
  },
});

export const fetchContests = (contests:any, series: any) => async (dispatch:any) => {
  dispatch(fetchContestsStatus(false));

  if (contests) {
    dispatch(fetchContestsSuccess(contests));
    dispatch(fetchContestsStatus(true));
    return;
  }

  dispatch(fetchContestsRequests());
  try {
    // TODO: sort series to get the HXRO, BTC, 1m sooner
    const getContests = series.filter((s:any)=> s.name.includes("BTC/USD") && s.contestDuration === "00:01:00").map(({ id }:{id:any}) =>
      getContestId(id).then((contests:any) => dispatch(fetchContestsSuccess(contests)))
    );

    await Promise.all(getContests);
    dispatch(fetchContestsStatus(true));
  } catch (err) {
    console.error('fetch contest failure', err);
    dispatch(fetchContestsFailure(err));
    dispatch(fetchContestsStatus(true));
  }
};

export const updateContest = (data:any) => (dispatch:any, getState:any) => {
  if (data.status === 'Closed') {
    const state = getState().contestSeries;
    const contest = state.contests[data.id];
    if (!contest) {
      return;
    }
    const seriesKey = getContestSeriesKey(contest);

    const { idToOmit } = (state.series[seriesKey] || []).reduce(
      (all:any, contestId:any) => {
        const item = state.contests[contestId];
        if (item) {
          const close = Date.parse(item.contestCloseTime);
          const deltaTime = close - all.now;
          if (deltaTime < 0 && all.currentLatest > deltaTime) {
            all.currentLatest = deltaTime;
            all.idToOmit = item.id;
          }
        }
        return all;
      },
      {
        now: Date.now(),
        currentLatest: 0,
        idToOmit: '',
      }
    );
    if (idToOmit !== '') {
      dispatch(omitContest({ seriesKey, idToOmit }));
    }
    dispatch(closeContest(data, idToOmit));
  } else {
    dispatch(setContestUpdated(data));
  }
};

export const setContestUpdated = (payload:any) => ({
  type: UPDATE_CONTEST,
  payload,
});

export const omitContest = (payload:any) => ({
  type: OMIT_CONTEST,
  payload,
});

export const addContestPlayed = (contest:any) => ({
  type: ADD_CONTEST_PLAYED,
  payload: { contest },
});

export const closeContest = (contestUpdate:any, idToOmit:any) => ({
  type: UPDATE_CONTEST_CLOSE,
  payload: { contestUpdate, idToOmit },
});
